var exports = {
  "a": "Box__2oonzK",
};

module.exports = exports;
